<script setup>
import { ref} from 'vue'
import FilterSearch from "@/components/explorer/filter/FilterSearch.vue"
import BannerMsg from "@/components/common/BannerInfo.vue"

//events raised by component
const emit = defineEmits([
	'closeFilterItemPanel',
	'updateFilterValue'
])

//componenet methods exposed to parent
defineExpose({
    initFilterItem
});

//binding used to invoke method on child component
const childRefFilterSearch = ref({})

//reactive field proxies
const dimValues = ref()
const dimName = ref()
const selectedValue = ref()	
const bannerMsg = ref('')
const chartType = ref({})

//local variables
let dim = {}; // ref({})

//methods
function initFilterItem(type, d) {
	//dimValues.value = d.appliedValues.filter(v => v.visible)
	//dimValues.value = d.appliedValues
	//Remove ALL if filtering categroy (series dim)
	dimValues.value = 
	d.appliedValues.forEach(i => {
		if(i.selected)
			selectedValue.value = i.name;
	})
	dimValues.value = d.appliedValues

	dimName.value = d.columnName
	dim = d

	childRefFilterSearch.value.initSearch()
	chartType.value = type 
	if(type == "line")
		bannerMsg.value = 'Variables not chosen in Categories are filtered to one option.'
	else if(type == "bar" || type == "column")
		bannerMsg.value = 'Variables not chosen in X-Axis Categories and Group are filtered to one option.'
	else if(type == "treemap")
		bannerMsg.value = 'Variables not chosen in Category and Detail are filtered to one option.'
	else if(type == "sankey")
		bannerMsg.value = 'Variables not chosen in Left and Right are filtered to one option.'
	else
		bannerMsg.value = ''
}


function closeFilter(type) {
	emit('closeFilterItemPanel', type);
}

 function updateFilter() {
	//console.log(dim)
	dim.appliedValues.forEach(i => {
		if(i.name == selectedValue.value)
			i.selected = true
		else
			i.selected = false
	})	
	emit('updateFilterValue', dim);
}

function filteredValues(matchedValues) {
	if(matchedValues == null) {
		dimValues.value = dim.appliedValues
	} else {
		dimValues.value = matchedValues
	}
}

function resetAll() {
	
	let defaultVal = dim.defaultValues.find(x => dim.distinctValues.includes(x))
	if(defaultVal !== undefined) {
		dim.appliedValues.forEach(i => {
			if(i.name == defaultVal) {		
				selectedValue.value = i.name
				i.selected = true;
			} else {
				i.selected = false;
			}
		})
	} else {
		let allVal = dim.totalLabel
		let totalLabelFound = dim.distinctValues.includes(allVal)
		dim.appliedValues.forEach(i => {
			if(totalLabelFound && i.name == allVal) {
				selectedValue.value = i.name	
				i.selected = true;
			} else {
				i.selected = false;
			}
		})
	}
	emit('updateFilterValue', dim);	
}
</script>

<template>
	<div class="filter-panel">
		<div class="filter-header">
			<button class="btn-icon btn-arrow" @click="closeFilter" aria-label="Back"><i class="fa-solid fa-chevron-left"></i> Back</button>
			<button class="btn-icon btn-close" @click="closeFilter('all')" aria-label="Close"><i class="fa-solid fa-times"></i></button>
		</div>
		<div class="filter-title">{{dimName}}</div>

		<div class="filter-body">
			<div class="filter-body-content">
				<FilterSearch ref="childRefFilterSearch" :dim="dim" @filteredValues="filteredValues" />
				<div v-if="chartType != 'map' && chartType != 'table'">
					<BannerMsg :show=true :type="'info side'" style="margin-top:1.25rem" :msgContent="bannerMsg"></BannerMsg>
				</div>		
				<div class="filters">
					<ul>
						<li v-for="dimVal in dimValues" :key="dimVal.name">
							<label class="blue-radio">
								<input type="radio" name="dimValues" :value="dimVal.name" v-model="selectedValue" @change="updateFilter">
								<span class="blue-mark"></span>
								<span class="fld-value">{{ dimVal.name }}</span>
							</label>
						</li>
					</ul>			
				</div>
				<div class="button-section">			
					<button class="btn-primary" @click="resetAll"> <i class="fa-solid fa-trash-can-undo"></i> Reset All </button>
				</div>
			</div>
		</div>
	</div>

	
</template>

<style scoped>
.filter-panel {
	background-color: var(--surface-color-Default);
	display: flex;
	width: 25rem; /* 400px; */ 
	flex-direction: column;
	align-items: flex-start;
	flex-direction: column;
	align-items: flex-start;
	gap: var(--spacing-xl, 1.5rem);
	flex-shrink: 0;
	padding: .75rem 1.25rem;
	border-radius: var(--ui-cards-default, 0.75rem);
	background: var(--surface-default, #FFF);
	height: 100%;
	/* UI Card */
	box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.15);	

	position:absolute;
	top:0;
	left:0;

}
.filter-header {
	display: flex;
	width: 100%; /* 394px; */
	height: 2.5rem;
	justify-content: space-between;
}

.filter-body {
	width: 100%;
	height: 100%;
	min-height: 0;
}

.filter-body-content {
	width: 100%;
	display: flex;
  	flex-direction: column;
  	height: 100%;
}

.filter-title {
	color: var(--text-Header, #171717);

	/* Medium/H6 */
	font-family: var(--font-family-Title, Roboto);
	font-size: var(--font-size-H6, 1.25rem);
	font-style: normal;
	font-weight: 500;
	line-height: var(--font-line-height-H6, 1.75rem); /* 140% */
}

.banner-container {
	margin-top: 1.5rem;
}

.btn-close {
	color: var(--icon-cta-Blue, #064291);
	text-align: right;
	font-weight: 900;
	line-height: normal;
	font-size: var(--font-size-H6);
	border: 0;
	background-color: transparent;
	min-width: 1rem;
}

.btn-arrow {
	min-width:0;
	color: var(--icon-cta-Blue, #064291);
	font-size: var(--font-size-Base);
	text-decoration: none;	
}


.filters {
	display: flex;
	padding-inline-start: 0;
	flex-direction: column;
	align-items: flex-start;
	align-self: stretch;
	margin-top: 1rem;
	list-style-type: none;
	/*height: 28.5rem;*/
	min-height: 0;
	overflow-y: auto;
	overflow-x: hidden;
}

ul {
	list-style-type: none;
    padding-left: 0;
    width: 100%;	
}

li {
	display: flex;
	align-items: center;
	align-self: stretch;
	height: 3rem;
	width: 100%;
}

.fld-value {
	padding-left: .25rem;
	color: var(--text-primary, #2C2C2C);

	/* Regular/Base */
	font-family: var(--font-family-Title, Roboto);
	font-size: var(--font-size-Base, 1rem);
	font-style: normal;
	font-weight: 400;
	line-height: var(--font-line-height-Base, 1.5rem); /* 150% */		
}

.blue-radio {
	display: flex;
	align-items: center;
	cursor: pointer;
	margin: 10px 0;
	position: relative;
	padding-left: 35px;
	font-size: 18px;
}

.blue-radio input[type="radio"] {
  display: none;
}

.blue-mark {
	position: absolute;
	left: 0;
	top: 0;
	height: 24px;
	width: 24px;
	background-color: #fff;
	border: 1px solid var(--icon-cta-Blue, #064291);;
	border-radius: 50%;
}

.blue-radio input[type="radio"]:checked + .blue-mark::after {
	content: "";
	position: absolute;
	top: 2px;
	left: 2px;
	width: 18px;
	height: 18px;
	border-radius: 50%;
	background: var(--icon-cta-Blue, #064291);;
}

.button-section {
	display: flex;
	justify-content:flex-end;
	width: 100%;
	border-top: 1px solid var(--border-color-Divider);
	padding-top: 1rem;
	margin-top: auto;
    /*position: absolute; /* causes overflowing filter-body */
	margin-top: auto; /* Pushes this div all the way to the bottom */
    bottom: 20px;
    left: 20px;
    width: stretch;
    right: 20px;	
}

/* 1023px - iPad */
@media (max-width: 63.9375rem) {
	.filter-panel {
		position:absolute;
		left: 0;
		top: 0;
		width: 100%;
		min-height: unset;
	}

	.filter-body {
		max-width: 31.1875rem;
		width: 100%;
	}

	.filters {
		min-height: unset;
	}
}

</style>